module.exports = __webpack_public_path__ + "static/media/thumbnail_insorb-for-use@3x.f971b669.jpg";